import { useQuery, useMutation } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function fetchAuthUrl() {
    const data = await client(`johndeere_oc/authorization_request/`)
    return data
}

export function useAuthUrl() {
    return useQuery(['johndeere_oc_auth'],  () => fetchAuthUrl(), {
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}

async function fetchToJohnDeereOC(data) {
    const res = await client(`johndeere_oc/upload_to_oc/`, { body: data })
    return res
}

export function useTransferToJohnDeereOC() {
    return useMutation(fetchToJohnDeereOC)
}
